import mapActions from './mapActions';

export default mapActions('logs', {
    fetchAll_url: date => `/api/logs/${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
});